module.exports = __webpack_public_path__ + "img/up.3b88b123.svg";